module.exports = __webpack_public_path__ + "svg/new-maestro-big.7928b273030d6ad722a840ba5a3d6cc8.svg";